<section *ngIf="lesson" class="task-lesson" [class.active-fullscreen]="isFullScreen">
  <div class="task-lesson__header"
      [routerLink]="['/teacher', 'prepare', 'new', lesson?.id]">
    <div class="task-lesson__header__wrapper">
      <span class="task-lesson__header__item__class">
        <ul>
          <li class="task-lesson__header__item__class__title">{{ classObj?.title }} класс</li>
          <li class="task-lesson__header__item__class__date">{{ lesson?.date | date: "dd.MM.yyyy" }}</li>
        </ul>
      </span>
      <span class="task-lesson__header__item__lesson-description">
        <ul>
          <li class="task-lesson__header__item__lesson-description__lesson-number">Занятие № {{ lesson?.lesson_number }}</li>
          <li><i><b>{{ lesson?.title }}</b></i></li>
          <li *ngIf="lesson?.remarks"><i><small>{{ lesson?.remarks }}</small></i></li>
        </ul>
      </span>
      <span class="task-lesson__header__item__extra">
        <span *ngIf="lesson?.status !== lesson_in_work"
          (click)="changeLessonStatus(lesson_created, $event)">
          <button mat-raised-button color="primary" class="task-lesson__header__item__extra__start-button">
            <mat-icon inline=true>play_circle_filled</mat-icon>
            Старт
          </button>
        </span>
        <span *ngIf="lesson?.status === lesson_in_work"
          (click)="changeLessonStatus(lesson_in_work, $event)">
          <button mat-raised-button color="accent" class="task-lesson__header__item__extra__stop-button">
            <mat-icon inline=true>stop</mat-icon>
            Стоп
          </button>
        </span>
        <app-time-correction-modal
          *ngIf="lesson"
          [lesson]="lesson"
          [lessonCompletedNotFinal]="lesson_completed_not_final"
          (lessonForUpdate)="changeLessonWithTimeCorrection($event)">
        </app-time-correction-modal>
      </span>
    </div>
  </div>
  <div class="task-lesson__body">
    <div class="task-lesson__body__class">
      <app-class
        (selectPupil)="selectStudent($event)"
        [selectedStudentIndex]="selectedStudentIndex"
        [isTeach]="isTeach"
        [students]="students"
        [lesson]="lesson"
        [privilegeSettings]="privilegeSettings">
      </app-class>
    </div>
    <div class="task-lesson__body__content">
      <span class="task-lesson__body__content__fullscreen">
        <button mat-icon-button aria-label="На весь экран"
          class="task-lesson__body__content__fullscreen__button"
          (click)="isFullScreen = !isFullScreen">
          <mat-icon *ngIf="!isFullScreen" class="task-lesson__body__content__fullscreen__button__icon">fullscreen</mat-icon>
          <mat-icon *ngIf="isFullScreen" class="task-lesson__body__content__fullscreen__button__icon">fullscreen_exit</mat-icon>
        </button>
      </span>
      <div class="task-lesson__body__content__search">
        <div *ngIf="selectedStudentId"
          class="card__info" [ngClass]="{'active': activeCard}">
          <div class="card__info__item search">
            <label for="cardNum">Вариант №</label>
            <div class="search__form">
              <input
                class="search__input"
                type="number"
                id="cardNum"
                aria-describedby="search-card"
                [(ngModel)]="cardNumber"
                [readonly]="!selectedStudentId"
                [ngClass]="{'active': selectedStudentId}"
                (keyup.enter)="keyupHandler()">
              <button
                class="search__button"
                type="button"
                id="search-card"
                [disabled]="!selectedStudentId"
                (click)="findCard()"
                [ngClass]="{'active': selectedStudentId}">
                <i class="fa fa-search" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="errorCard != null" class="text-danger">
          {{ errorCard }}
        </div>
        <div *ngIf="selectedStudentId && exExercise?.id && !activeCard"
          class="ex-exercise"
          (click)="showExExerciseModal(exExerciseTemplate)">
          <span class="ex-exercise__btn" [class.disabled]="!availableCardId">
            <span class="text"><span>Доп. задание:</span> {{ exExercise.title }}</span>
          </span>
          <ng-template #exExerciseTemplate>
            <div class="modal-body">
              <app-ex-exercise-modal
                [modalRef]="modalRef"
                [exExercise]="exExercise"
                [pupil]="currentStudent"
                [availableCardId]="availableCardId"
                [currentLesson]="lesson"
                (closeModal)="closeModal()"
                (clearCardNumber)="clearCardNumber()"
              ></app-ex-exercise-modal>
            </div>
          </ng-template>
        </div>
      </div>
      <app-habirint-table *ngIf="!selectedStudentId && lesson?.is_habirint"
        [lesson]="lesson"
        [privilegeSettings]="privilegeSettings">
      </app-habirint-table>
      <div class="task-lesson__body__content__card">
        <app-cards
          *ngIf="activeCard"
          [activeCard]="activeCard"
          [exExercise]="exExercise"
          [student]="currentStudent"
          [students]="students"
          [lesson]="lesson"
          [profile]="profile"
          [lessonPrivilegeSettings]="privilegeSettings"
          [hasKairosBonus]="studentHasKairosBonus"
          (clearCard)="clearCardNumber()"
          (firstCheckCard)="firstCheckCard()"
          (updateLessonStatus)="updateLessonStatus($event)">
        </app-cards>
      </div>
    </div>
  </div>
</section>

<!-- Modal -->
<div class="modal result-modal fade" id="messageModal" #taskModal="bs-modal" bsModal>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row action-options align-items-center">
          <div class="col-9 text-center">
            <div class="top col-12 text-center">
              <p>{{ modalMessage }}</p>
            </div>
          </div>
          <div class="col-3 text-left">
            <a class="action-options-btn green_txt" (click)="hideModal()" data-dismiss="modal" style="cursor: pointer">ОК</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
